function getKeyCode(evt) {
    const key = evt.key;
    let keyCode = evt.keyCode;
    if (key && !keyCode) {
        keyCode = key.charCodeAt(0);
    }
    return keyCode;
}

function isBackspace(keyCode) {
    return keyCode && keyCode === 8;
}

function isEnterKey(keyCode) {
    return keyCode && keyCode === 13;
}

function matchesPattern(regex, value) {
    return regex.test(value);
}

module.exports = function () {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            function isNumeric(keyCode) {
                return (keyCode && keyCode >= 48 && keyCode <= 57) || keyCode === 46;
            }
            element.bind('keypress', (event) => {
                const keyCode = getKeyCode(event);
                if (!isBackspace(keyCode) && !isNumeric(keyCode) && !isEnterKey(keyCode)) {
                    event.preventDefault();
                }

                const previousValue = element.val().split('.')[1];
                const numberOfDecimalPlaces = scope.$eval(attrs.restrictPartialAlpha);
                if (previousValue && previousValue.length === numberOfDecimalPlaces) {
                    event.preventDefault();
                }
            });
            element.bind('keyup', () => {
                if (!matchesPattern(/^\d*[.]?\d{0,2}$/, element.val())) {
                    element.val('');
                }
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/wallet/giftcard/restrict-partial-alpha.directive.js